import { adminRouteList } from './admin/route'

export const AppRouteList = [...adminRouteList]
